import { Injectable } from '@angular/core';
import { UserUrl } from '../../../shared/urls/user.url';
import { OrganizationUrl } from '../../../shared/urls/company-account.url';
import { BaseService } from '../../../shared/services/base.service';
@Injectable()
export class SearchPatientService {
    constructor(public baseService: BaseService) {
    }

    getListGender() {
        return [
            {
                id: 0,
                name: 'Male'
            },
            {
                id: 1,
                name: 'Female'
            }
        ];
    }

    getListParty() {
        return this.baseService.getAll(OrganizationUrl.ORGANIZATION_DROP_DOWN_LIST);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/search-patient/search-patient.service.ts